module.exports = __webpack_public_path__ + "do.48badacf.svg";